import React, { useState, useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";
import AssetsListLayer from "../components/AssetsListLayer";

const AssetsListPage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchAssets = async () => {
    const locationId =  localStorage.getItem('locationID')
    setLoading(true);

    const user = JSON.parse(localStorage.getItem("user"));
    if (!user) return (window.location.href = "/sign-in");

    try {
      const res = await fetch(`${API_URL}/api/assets?locationId=${locationId}`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      });

      const result = await res.json();
      setData(result.data || []);
    } catch (error) {
      console.error("Failed to load assets", error);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchAssets();
  }, []);

  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Assets - List" />

        {loading && (
          <div className="text-center mt-4">
            <Spinner />
          </div>
        )}

        {!loading && data.length === 0 && (
          <div className="text-center mt-4">
            <p>No Assets found...</p>
          </div>
        )}

        {data.length > 0 && <AssetsListLayer assetsData={data} />}
      </MasterLayout>
    </>
  );
};

export default AssetsListPage;
